/* IZU Paros product page: gallery, variants, add to bag, sticky bar, modals. Plain JavaScript, no libraries. */
(() => {
  const root = document.querySelector("[data-pd]");
  if (!root) return;
  const $ = (s, r = root) => r.querySelector(s);
  const $$ = (s, r = root) => Array.from(r.querySelectorAll(s));
  const desktop = window.matchMedia("(min-width: 961px)");

  // ---------- Gallery ----------
  const track = $("[data-pd-track]");
  const slides = $$(".pd__slide", track);
  const thumbs = $$("[data-pd-thumb]");
  const dots = $$(".pd__dot");
  let current = 0;

  function show(i, scroll) {
    if (!slides.length) return;
    current = Math.max(0, Math.min(slides.length - 1, i));
    slides.forEach((s, n) => s.classList.toggle("is-active", n === current));
    thumbs.forEach((t, n) => { t.classList.toggle("is-on", n === current); if (n === current) t.setAttribute("aria-current", "true"); else t.removeAttribute("aria-current"); });
    dots.forEach((d, n) => d.classList.toggle("is-on", n === current));
    if (!scroll) return;
    if (desktop.matches) slides[current].scrollIntoView({ behavior: "smooth", block: "nearest" });
    else track.scrollTo({ left: current * track.clientWidth, behavior: "smooth" });
  }
  thumbs.forEach(t => t.addEventListener("click", () => show(Number(t.dataset.index))));
  track.addEventListener("scroll", () => {
    if (desktop.matches || !track.clientWidth) return;
    const i = Math.round(track.scrollLeft / track.clientWidth);
    if (i !== current) show(i, false);
  }, { passive: true });

  // ---------- Dialogs (native <dialog>: focus is trapped, Esc closes, focus returns to the opener) ----------
  function openDialog(dlg, opener) {
    if (!dlg) return;
    dlg._opener = opener || document.activeElement;
    if (typeof dlg.showModal === "function") dlg.showModal(); else dlg.setAttribute("open", "");
    document.body.classList.add("locked");
    const close = $("[data-pd-close]", dlg); if (close) close.focus();
  }
  function closeDialog(dlg) {
    if (!dlg) return;
    if (typeof dlg.close === "function") dlg.close(); else dlg.removeAttribute("open");
  }
  $$("dialog", root).forEach(dlg => {
    dlg.addEventListener("close", () => { document.body.classList.remove("locked"); if (dlg._opener && dlg._opener.focus) dlg._opener.focus(); });
    dlg.addEventListener("click", e => { if (e.target === dlg) closeDialog(dlg); });
    $$("[data-pd-close]", dlg).forEach(b => b.addEventListener("click", () => closeDialog(dlg)));
    // Keep Tab inside the dialog
    dlg.addEventListener("keydown", e => {
      if (e.key !== "Tab") return;
      const f = Array.from(dlg.querySelectorAll("button, a[href], input, select, textarea, [tabindex]:not([tabindex='-1'])")).filter(el => !el.disabled && el.offsetParent !== null);
      if (!f.length) { e.preventDefault(); return; }
      const first = f[0], last = f[f.length - 1];
      if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
      else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
    });
  });

  const lightbox = $("[data-pd-lightbox]"), lightImg = $("[data-pd-lightbox-img]");
  $$("[data-pd-zoom]").forEach(btn => btn.addEventListener("click", () => {
    if (!lightbox) return;
    const img = $("img", btn);
    lightImg.src = btn.dataset.full || (img && img.src) || "";
    lightImg.alt = (img && img.alt) || "";
    openDialog(lightbox, btn);
  }));
  // Swipe down to close the image lightbox (touch only; click-outside and the close button already work everywhere)
  if (lightbox) {
    let touchStartY = null, touchDeltaY = 0;
    lightbox.addEventListener("touchstart", e => {
      if (e.touches.length !== 1) return;
      touchStartY = e.touches[0].clientY; touchDeltaY = 0;
      lightImg.style.transition = "none";
    }, { passive: true });
    lightbox.addEventListener("touchmove", e => {
      if (touchStartY === null) return;
      touchDeltaY = Math.max(0, e.touches[0].clientY - touchStartY);
      lightImg.style.transform = `translateY(${touchDeltaY}px)`;
      lightImg.style.opacity = String(Math.max(.4, 1 - touchDeltaY / 400));
    }, { passive: true });
    lightbox.addEventListener("touchend", () => {
      lightImg.style.transition = "";
      if (touchDeltaY > 90) { closeDialog(lightbox); }
      lightImg.style.transform = ""; lightImg.style.opacity = "";
      touchStartY = null; touchDeltaY = 0;
    });
  }
  // Every size-guide trigger (the link beside the sizes and the utility line under Add to bag) opens the same dialog
  const guideModal = $("[data-pd-guide-modal]");
  if (guideModal) document.querySelectorAll("[data-pd-guide]").forEach(btn => btn.addEventListener("click", () => openDialog(guideModal, btn)));

  // ---------- Notify me when available: reveals a small inline email form ----------
  const notifyToggle = $("[data-pd-notify]"), notifyBox = $("[data-pd-notify-form]");
  if (notifyToggle && notifyBox) notifyToggle.addEventListener("click", () => {
    notifyBox.hidden = !notifyBox.hidden;
    if (!notifyBox.hidden) { const input = $("input[type=email]", notifyBox); if (input) input.focus(); }
  });
  // Arriving from a sold-out card's "Notify me" link (#notify): open the form straight away
  if (location.hash === "#notify" && notifyToggle && notifyBox && !notifyToggle.hidden) {
    notifyBox.hidden = false;
    notifyBox.scrollIntoView({ block: "center" });
    const input = $("input[type=email]", notifyBox); if (input) input.focus({ preventScroll: true });
  }

  // ---------- Fabric close-up: round view ----------
  const fabricBtn = $("[data-pd-fabric]"), fabricModal = $("[data-pd-fabric-modal]");
  if (fabricBtn && fabricModal) fabricBtn.addEventListener("click", () => openDialog(fabricModal, fabricBtn));

  // ---------- Styling video: nothing loads, and nothing plays, until it is tapped; it always starts muted ----------
  const videoBox = $("[data-pd-video]");
  if (videoBox) {
    const play = $("[data-pd-video-play]", videoBox);
    play.addEventListener("click", () => {
      const tpl = $("[data-pd-video-tpl]", videoBox);
      if (tpl) {
        const frag = tpl.content.cloneNode(true), v = frag.querySelector("video");
        if (v) { v.muted = true; v.controls = true; v.setAttribute("playsinline", ""); v.removeAttribute("autoplay"); v.preload = "metadata"; }
        play.replaceWith(frag);
        const live = $("video", videoBox); if (live) { live.muted = true; const pr = live.play(); if (pr && pr.catch) pr.catch(() => {}); }
      } else {
        const note = $("[data-pd-video-note]", videoBox); if (note) note.hidden = false;
        play.setAttribute("aria-expanded", "true");
      }
    });
  }

  // ---------- Variants ----------
  let variants = [];
  try { variants = JSON.parse($("[data-pd-variants]").textContent || "[]"); } catch (e) { variants = []; }
  const idSelect = $("[data-pd-id]");
  const groups = $$("[data-pd-option]");
  const priceEl = $("[data-pd-price]"), priceBar = $("[data-pd-price-bar]");
  const stockEl = $("[data-pd-stock]"), msgEl = $("[data-pd-msg]");
  const reserveBtn = $("[data-pd-reserve]"), notifyBtn = $("[data-pd-notify]"), notifyForm = $("[data-pd-notify-form]");
  const barReserveBtn = $("[data-pd-bar-reserve]");
  const buyBtns = $$("[data-pd-buy]"), buyLabels = $$("[data-pd-buy-label]");
  const reduceMotion = window.matchMedia("(prefers-reduced-motion: reduce)");
  let state = "idle", resetTimer = null;
  const labelNow = text => buyLabels.forEach(l => { l.textContent = text; });
  const setLabel = text => buyLabels.forEach(l => {
    if (l.textContent === text) return;
    if (reduceMotion.matches) { l.textContent = text; return; }
    l.style.opacity = "0"; setTimeout(() => { l.textContent = text; l.style.opacity = ""; }, 120);
  });
  const barBtn = $("[data-pd-bar-buy]");
  const chosen = () => groups.map(g => { const c = $("input:checked", g); return c ? c.value : null; });
  const find = sel => variants.find(v => v.options.every((o, i) => o === sel[i]));

  function refresh(fromUser) {
    const sel = chosen();
    const v = groups.length ? find(sel) : variants[0];

    groups.forEach((g, i) => {
      const out = $("[data-pd-opt-value]", g); if (out && sel[i]) out.textContent = sel[i];
      $$("input", g).forEach(inp => {
        const test = sel.slice(); test[i] = inp.value;
        const m = find(test), ok = !!(m && m.available);
        inp.disabled = !ok && !inp.checked;
        const label = inp.nextElementSibling; if (label) label.classList.toggle("is-unavailable", !ok);
      });
    });

    if (!v) {
      buyBtns.forEach(b => { b.hidden = true; b.disabled = true; });
      if (reserveBtn) reserveBtn.hidden = false;
      if (barReserveBtn) barReserveBtn.hidden = false;
      if (notifyBtn) notifyBtn.hidden = false;
      applyBar();
      return;
    }
    const ok = !!v.available;
    if (idSelect) idSelect.value = String(v.id);
    if (priceEl) priceEl.innerHTML = (v.compare ? `<s class="card__was">${v.compare}</s> ` : "") + v.price;
    if (priceBar) priceBar.textContent = v.price;
    if (stockEl) {
      const low = ok && v.stock !== null && v.stock > 0 && v.stock < 4;
      stockEl.hidden = !low; stockEl.textContent = low ? `Only ${v.stock} left` : "";
    }
    if (state === "idle") { buyBtns.forEach(b => { b.hidden = !ok; b.disabled = false; }); labelNow("Add to bag"); }
    if (reserveBtn) reserveBtn.hidden = ok;
    if (barReserveBtn) barReserveBtn.hidden = ok;
    if (notifyBtn) notifyBtn.hidden = ok;
    if (!ok && notifyForm) notifyForm.hidden = true;
    applyBar();
    if (fromUser) {
      if (v.image >= 0) show(v.image, true);
      try { history.replaceState(null, "", `?variant=${v.id}`); } catch (e) { /* ignore */ }
    }
  }
  groups.forEach(g => g.addEventListener("change", () => refresh(true)));

  // ---------- Add to bag ----------
  const form = $("#pd-form");
  const say = (text, isError) => { if (!msgEl) return; msgEl.textContent = text; msgEl.classList.toggle("is-error", !!isError); };
  const setState = st => { state = st; buyBtns.forEach(b => { b.dataset.state = st; b.setAttribute("aria-busy", st === "adding" ? "true" : "false"); }); };
  const lockWidth = () => buyBtns.forEach(b => { b.style.minWidth = b.offsetWidth + "px"; });
  const unlockWidth = () => buyBtns.forEach(b => { b.style.minWidth = ""; });
  function backToIdle() {
    clearTimeout(resetTimer);
    setState("idle");
    buyBtns.forEach(b => { b.disabled = false; });
    setLabel("Add to bag");
    setTimeout(unlockWidth, 200);
  }
  if (form) form.addEventListener("submit", e => {
    e.preventDefault();
    if (state !== "idle") return;
    clearTimeout(resetTimer); say("");
    lockWidth(); setState("adding"); setLabel("Adding\u2026");
    buyBtns.forEach(b => { b.disabled = true; });
    const data = new FormData(form);
    fetch((form.getAttribute("action") || "/cart/add") + ".js", { method: "POST", body: data, headers: { Accept: "application/json" } })
      .then(r => r.json().then(j => ({ ok: r.ok, j })))
      .then(({ ok, j }) => {
        if (!ok || (j && j.status && j.description)) throw new Error((j && (j.description || j.message)) || "Could not add this piece.");
        say("Added to your bag.");
        document.dispatchEvent(new CustomEvent("izu:cart-changed"));
        setState("added"); setLabel("Added \u2713");
        resetTimer = setTimeout(backToIdle, 1800);
      })
      .catch(err => { say(err.message || "Something went wrong. Please try again.", true); backToIdle(); });
  });

  // ---------- Sticky bar (phones): appears once the main CTA has scrolled out of view, hides again
  // near the footer or once the main CTA is back in view. Observes a stable wrapper (not the buy button
  // itself), since that button is hidden entirely (not just disabled) when the variant is unavailable. ----------
  const bar = $("[data-pd-bar]"), ctaAnchor = $("[data-pd-cta-anchor]");
  const footerEl = document.querySelector(".footer");
  let barWanted = false, nearFooter = false;
  const applyBar = () => { if (bar) bar.hidden = !(barWanted && !nearFooter); };
  if (bar && ctaAnchor && "IntersectionObserver" in window) {
    new IntersectionObserver(entries => {
      const en = entries[0];
      barWanted = !desktop.matches && !en.isIntersecting && en.boundingClientRect.top < 0;
      applyBar();
    }, { threshold: 0 }).observe(ctaAnchor);
  }
  if (bar && footerEl && "IntersectionObserver" in window) {
    new IntersectionObserver(entries => {
      nearFooter = entries[0].isIntersecting;
      applyBar();
    }, { threshold: 0, rootMargin: "0px 0px -10% 0px" }).observe(footerEl);
  }

  refresh(false);
})();
